
<div
  class="blur-overlay"
  [class.visible]="isPanelOpen"
  (click)="closePanel()"
></div>

<div class="profile-panel" [class.open]="isPanelOpen">
  <!-- Botón de cierre -->
  <button class="btn close-btn" (click)="closePanel()">
    <i
      style="
        font-weight: 300;
        font-style: normal;
        transform: scaleX(1.3);
        display: inline-block;
      "
      class="fa-thin fa-x fa-lg"
    ></i>
  </button>

  <!-- Perfil: imagen + nombre/rol -->
  <div class="d-flex align-items-center gap-3 mt-2">
    <div class="profile-image-wrapper">
      <img [src]="userProfileImage || './../../../../assets/images/no-photo-user.jpg'" alt="Foto de usuario" />
    </div>
    <div class="d-flex flex-column">
      <h1 class="h5 mb-1">{{userName}}</h1>
      <p class="text-muted small">{{userRole}}</p>
    </div>
  </div>

  <!-- Opciones (nóminas y vacaciones) -->
  <div class="d-flex flex-column mt-5 gap-5">
    <a
      *ngFor="let item of profileNavBarItems"
      [href]="item.url"
      target="_blank"
      rel="noopener noreferrer"
      class="d-flex align-items-center text-decoration-none"
    >
      <img
        [src]="item.icon"
        alt="{{ item.label }} icon"
        width="32"
        height="32"
        class="me-3"
      />
      <p class="mb-0 fw-bold text-dark" style="font-size: 20px;">{{ item.label }}</p>
    </a>
  </div>



<!-- Cerrar sesión -->
<div class="logout d-flex justify-content-between align-items-center mt-auto pt-4 w-100">
  <h1 class="h5 mb-0">Cerrar sesión</h1>
  <i class="fa-solid fa-power-off fa-2x text-dark"></i>
</div>

</div>
